import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c2esz2g9h4: FaireBrandEntity = {
  token: "b_c2esz2g9h4",
  type: "brand",
  name: "Blue Stripes",
  avatarUrl:
    "https://cdn.faire.com/fastly/c039543508e7f255097bc2970da3c07dae2ea9da0df611325c41d6da8392f91d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0264129d5559b361ec16c1e37f8181aeab6cdee6b1d38b678dddc07629c8b370.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c039543508e7f255097bc2970da3c07dae2ea9da0df611325c41d6da8392f91d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0264129d5559b361ec16c1e37f8181aeab6cdee6b1d38b678dddc07629c8b370.jpeg",
  location: "Cedar Falls, IA, USA",
  minimumOrderDollars: 29,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "THE CHOCOLATE INDUSTRY WASTES 70% OF THE CACAO POD USING THE BEANS ONLY. BLUE STRIPES UPCYCLES THE WHOLE CACAO SHELL + FRUIT + BEANS TO ELEVATE YOUR DAILY NUTRITION.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:29.501Z",
    importedBy: "entity-db-cli",
  },
};
